module.exports = __webpack_public_path__ + "static/media/loading.0ef9463b.gif";


//////////////////
// WEBPACK FOOTER
// ./example/src/containers/Search/loading.gif
// module id = 201
// module chunks = 0